import {Nullish} from 'shared/web';

import {EitherQuantityOrError} from '../types/basket/EitherQuantityOrError';
import {IdentifiableBasketItem} from '../types/basket/IdentifiableBasketItem';
import {useBasketItemIdsSet} from './useBasketItemIdsSet';

/**
 * Tracks basket items whose quantity has been changed on the frontend but not sent
 * to the server yet, because the change is still waiting in the debounce.
 */
export function usePendingQuantityChangeIds(basketItems: IdentifiableBasketItem[] | Nullish) {
  const {hasIds, setId} = useBasketItemIdsSet(basketItems);

  const setPendingQuantityChangeItemId = (itemId: string, quantity: EitherQuantityOrError) =>
    setId(itemId, quantity.hasPendingQuantityChange);

  return {setPendingQuantityChangeItemId, hasPendingQuantityChange: hasIds};
}
